import { TeamUserClient } from '../types'

export const getUsers = (base: TeamUserClient) => () =>
  base.requester.get<any>('', { withCredentials: true })
